<template>

  <section class="card" :class="$props.class">
    <div class="card-body">
      <h3 class="card-title" v-if="title">
        <span class="section-title">{{ title }}</span>
      </h3>
      <slot></slot>
    </div>
  </section>

</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'StihlSection',
  props: {
    class: { type: String, default: 'stihl-section' },
    title: String,
  }
});
</script>
